/*
*
* File JS componente Hero Section
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './video-block.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const videoBlock = () => {
    const marqueeList = document.querySelectorAll('.marquee-section .marquee ul li');

    marqueeList.forEach((el, i) => {
        const clone = el.cloneNode(true);
        el.parentElement.appendChild(clone);
    });


    const videoBtn = document.querySelector('#playButton');
    const modal = document.getElementById('videoModal');
    const closeModal = document.querySelector('.video-modal .close');
    const video = document.getElementById('modal-video');

    if (videoBtn && modal)
        videoBtn.addEventListener('click', function () {
            modal.style.display = 'flex';
            video.play();
        });

    if (closeModal && modal)
        closeModal.addEventListener('click', function () {
            console.log('closeModal')
            modal.style.display = 'none';
            video.pause();
        });

    if (modal && video)
        window.addEventListener('click', function (event) {
            if (event.target === modal) {
                modal.style.display = 'none';
                video.pause();
            }
        });
}

export default videoBlock;

//--------------------------------------------------------------------//